/* eslint-disable import/extensions */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable camelcase */
/* eslint-disable object-curly-newline */
import React, {
 useState, useContext, useMemo, useEffect, useRef, useCallback
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { updateSimSelectionState, setSimType } from '@apps/redux/features/SimSelectionSlice'
import { APPLICATION_STATE, ApplicationContext } from '@apps/contexts/ApplicationContext'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { getBySlug } from '@apps/utils/contentful'
import {
  getPreferredSimSelectionText,
  getSimSelectionPageContent
} from '@apps/utils/simSelectionContent'
import { isIOS, isMobile } from 'react-device-detect'
import { BrandName, SIM_OPTIONS , ANALYTICS_EVENT_TYPES } from '@apps/utils/constants'
import Sites from '@sites/index'
import PropTypes from 'prop-types'
import {
  Button as KoodoButton,
  Icon,
  Input as KoodoInput,
  Typography
} from '@telus/koodo-ui-kit'
import RoundedButton from '@/apps/components/RoundedButton'
import PhoneDetails from '@/apps/components/PhoneDetails'
import InlineInstructionMarkdown from '@/apps/components/InlineInstructionMarkdown'
import useIsMobileScreen from '@/apps/hooks/isMobileScreen'
import useTagManagerInfo from '../../../_engine/hooks/useTagManagerInfo'

const SECTION_HEADING_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 20,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: '28px'
}
const INSTRUCTION_HEADING_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: 0,
  lineHeight: '20px'
}
const BODY_COPY_TOKENS = {
  color: '#000000',
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: '20px'
}
const BODY_BOLD_TOKENS = {
  color: '#000000',
  fontName: 'StagSans',
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: '20px'
}

const isApiFlagTrue = (value) => `${value || ''}`.toUpperCase() === 'TRUE'
const IMEI_INPUT_ID = 'input-imei'
const IMEI_DELETE_KEYS = ['Backspace', 'Delete']
const IMEI_POINTER_RELEASE_FALLBACK_MS = 1000

const ConsumerESIMCompatibility = ({
  autoLookup = false,
  continueLabel,
  continueTestId,
  onCompatibleContinue,
  onChoosePSim,
  showTopBorder = true
}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const isMobileScreen = useIsMobileScreen()

  const simSelectionState = useSelector((state) => state.simSelectionPage)
  const { simType } = useSelector((state) => state.simSelectionPage.selectSimType || {})
  const { pageContent } = useSelector((state) => state.common.content)
  const { imei } = simSelectionState

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.SERVICES]: { getDeviceInfo }
  } = useContext(ApplicationContext)
  
  const tagManagerInfo = useTagManagerInfo()
  
  const pushClickAnalytics = ({ click_text, journey_type,event_type, field_warning, error_response_code, event_click = ANALYTICS_EVENT_TYPES.CLICK }={}) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'click', region, language, {
        ...tagManagerInfo,
        click_text,
        journey_type,
        field_warning, 
        error_response_code
      }, event_type, event_click)
    )
  }

  const haveSimPageContent = getSimSelectionPageContent(pageContent, language, Sites.consumer)
  const { shortTextFields, longTextFields } = haveSimPageContent

  const [customerIMEI, setCustomerIMEI] = useState('')
  const [deviceInfo, setDeviceInfo] = useState()
  const [foundIMEI, setIMEIFound] = useState(null)
  const [disableIMEI, setDisableIMEI] = useState(true)
  const [hasImeiFormatError, setHasImeiFormatError] = useState(false)
  const [loading, setLoading] = useState(false)
  const latestIMEIRef = useRef('')
  const lastAutoLookupIMEIRef = useRef('')
  const hasClearedCurrentIMEIResultRef = useRef(false)
  const lastIMEIKeyRef = useRef('')
  const imeiDeleteScrollPositionRef = useRef(null)
  const imeiScrollRestoreFrameRef = useRef(null)
  const imeiScrollRestoreTimerRef = useRef(null)
  const imeiInputContainerRef = useRef(null)
  const imeiCompatibilityRef = useRef(null)
  const imeiHeightReleaseTimerRef = useRef(null)
  const imeiPointerActiveRef = useRef(false)
  const imeiHeightReleasePendingRef = useRef(false)
  const preservedIMEISectionHeightRef = useRef(0)
  const [preservedIMEISectionHeight, setPreservedIMEISectionHeight] = useState(0)

  const pageTextContent = useMemo(() => {
    if (!shortTextFields) return {}
    return {
      beforeYouProceedHeading:
        getBySlug(shortTextFields, 'beforeYouProceedHeading')?.value,
      eSimBenefitsMessage:
        getBySlug(shortTextFields, 'eSimBenefitsMessage')?.value,
      eSimImeiInstructions:
        getBySlug(shortTextFields, 'eSimImeiInstructions')?.value,
      checkPhoneSettings:
        getBySlug(shortTextFields, 'checkPhoneSettings')?.value,
      dialPhoneCode:
        getBySlug(shortTextFields, 'dialPhoneCode')?.value,
      enterYourIMEI: getBySlug(shortTextFields, 'enterYourIMEI')?.value,
      imeiInvalid:
        getBySlug(shortTextFields, 'imeiInvalid')?.value,
      checkIMEI: getBySlug(shortTextFields, 'checkIMEI')?.value,
      imeiNotFound: getBySlug(shortTextFields, 'imeiNotFound')?.value,
      imeiNotFoundMessage:
        getPreferredSimSelectionText(
          longTextFields,
          shortTextFields,
          'imeiNotFoundMessage'
        ),
      eSimIncompatible:
        getBySlug(shortTextFields, 'eSimIncompatible')?.value,
      eSimNotCompatibleMessage:
        getPreferredSimSelectionText(
          longTextFields,
          shortTextFields,
          'eSimNotCompatibleMessage'
        ),
      proceedWithESIM: getBySlug(shortTextFields, 'proceedWithESIM')?.value,
      getNewPhysicalSIM: getBySlug(shortTextFields, 'getNewPhysicalSIM')?.value,
      pSimCost: getBySlug(shortTextFields, 'pSimCost')?.value
    }
  }, [shortTextFields, longTextFields])

  const pSimPrice = Number.isNaN(parseFloat(pageTextContent?.pSimCost))
    ? 0
    : parseFloat(pageTextContent?.pSimCost)

  const updateIMEICompatibilityCheck = (newState) => {
    dispatch(updateSimSelectionState(newState))
  }

  const isIMEIComplete = (value) => value.length >= 14 && value.length <= 15
  const isAutoLookupReady = (value) => isIMEIComplete(value)

  const hasIMEICompatibilityResult = () => {
    return Boolean(foundIMEI !== null ||
      deviceInfo ||
      imei ||
      simSelectionState.imeiChecked ||
      simSelectionState.imeiCompatible)
  }

  const captureIMEIDeleteScrollPosition = () => {
    if (autoLookup || !isIOS || typeof window === 'undefined') return
    imeiDeleteScrollPositionRef.current = {
      scrollX: window.scrollX || window.pageXOffset || 0,
      scrollY: window.scrollY || window.pageYOffset || 0
    }
  }

  const preserveIMEIDeleteScrollPosition = () => {
    const scrollPosition = imeiDeleteScrollPositionRef.current
    if (autoLookup || !isIOS || !scrollPosition || typeof window === 'undefined') return

    const activeElement = typeof document !== 'undefined' ? document.activeElement : null
    if (!activeElement || !imeiInputContainerRef.current?.contains(activeElement)) return

    imeiDeleteScrollPositionRef.current = null
    const restoreScroll = () => {
      const currentActiveElement = typeof document !== 'undefined'
        ? document.activeElement
        : null
      const inputStillFocused = currentActiveElement &&
        imeiInputContainerRef.current?.contains(currentActiveElement)

      if (imeiCompatibilityRef.current && inputStillFocused) {
        window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY)
      }
    }

    if (imeiScrollRestoreFrameRef.current !== null) {
      if (typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(imeiScrollRestoreFrameRef.current)
      } else {
        clearTimeout(imeiScrollRestoreFrameRef.current)
      }
    }
    clearTimeout(imeiScrollRestoreTimerRef.current)

    // iOS WebKit may move the page after focused input rerenders; restore after paint.
    if (typeof window.requestAnimationFrame === 'function') {
      imeiScrollRestoreFrameRef.current = window.requestAnimationFrame(() => {
        imeiScrollRestoreFrameRef.current = null
        restoreScroll()
      })
    } else {
      imeiScrollRestoreFrameRef.current = setTimeout(() => {
        imeiScrollRestoreFrameRef.current = null
        restoreScroll()
      }, 0)
    }
    imeiScrollRestoreTimerRef.current = setTimeout(() => {
      imeiScrollRestoreTimerRef.current = null
      restoreScroll()
    }, 75)
  }

  const preserveIMEIAutoLookupSectionHeight = () => {
    if (!autoLookup || !isIOS) return

    const activeElement = typeof document !== 'undefined' ? document.activeElement : null
    if (!activeElement || !imeiInputContainerRef.current?.contains(activeElement)) return

    const { height = 0 } = imeiCompatibilityRef.current?.getBoundingClientRect() || {}
    if (height > 0) {
      setPreservedIMEISectionHeight((currentHeight) => {
        const nextHeight = Math.max(currentHeight, height)
        preservedIMEISectionHeightRef.current = nextHeight
        return nextHeight
      })
    }
  }

  const releaseIMEIAutoLookupSectionHeight = useCallback(() => {
    clearTimeout(imeiHeightReleaseTimerRef.current)
    const activeElement = typeof document !== 'undefined' ? document.activeElement : null
    const focusRemainsInSection = activeElement &&
      imeiCompatibilityRef.current?.contains(activeElement)

    if (imeiCompatibilityRef.current && !focusRemainsInSection) {
      imeiHeightReleasePendingRef.current = false
      preservedIMEISectionHeightRef.current = 0
      setPreservedIMEISectionHeight(0)
    }
  }, [])

  const scheduleIMEIAutoLookupSectionHeightRelease = useCallback((delay = 0) => {
    clearTimeout(imeiHeightReleaseTimerRef.current)
    imeiHeightReleaseTimerRef.current = setTimeout(
      releaseIMEIAutoLookupSectionHeight,
      delay
    )
  }, [releaseIMEIAutoLookupSectionHeight])

  const handleIMEISectionFocus = () => {
    if (!autoLookup || !isIOS) return
    imeiHeightReleasePendingRef.current = false
    clearTimeout(imeiHeightReleaseTimerRef.current)
  }

  const handleIMEISectionBlur = (event) => {
    if (!autoLookup || !isIOS || preservedIMEISectionHeightRef.current === 0) return
    if (event.currentTarget.contains(event.relatedTarget)) return

    imeiHeightReleasePendingRef.current = true
    if (!imeiPointerActiveRef.current) {
      scheduleIMEIAutoLookupSectionHeightRelease()
    }
  }

  const onIMEIChange = (value) => {
    const sanitizedIMEI = `${value || ''}`.replace(/\D/g, '').slice(0, 15)
    const wasDeletingIMEI =
      sanitizedIMEI.length < latestIMEIRef.current.length ||
      IMEI_DELETE_KEYS.includes(lastIMEIKeyRef.current)

    if (wasDeletingIMEI && !imeiDeleteScrollPositionRef.current) {
      captureIMEIDeleteScrollPosition()
    }

    setCustomerIMEI(sanitizedIMEI)
    latestIMEIRef.current = sanitizedIMEI
    setDisableIMEI(!isIMEIComplete(sanitizedIMEI))
    setHasImeiFormatError(false)
    setLoading(false)

    if (!isAutoLookupReady(sanitizedIMEI)) {
      lastAutoLookupIMEIRef.current = ''
    }

    if (hasIMEICompatibilityResult()) {
      if (wasDeletingIMEI) {
        // Keep the total IMEI section height stable while its result is removed.
        // This prevents iOS from clamping the page upward under the open keyboard.
        preserveIMEIAutoLookupSectionHeight()
      }
      setIMEIFound(null)
      setDeviceInfo(undefined)

      if (!hasClearedCurrentIMEIResultRef.current) {
        hasClearedCurrentIMEIResultRef.current = true
        updateIMEICompatibilityCheck({
          imei: '',
          imeiChecked: false,
          imeiCompatible: false
        })
      }
    }

    if (wasDeletingIMEI) {
      preserveIMEIDeleteScrollPosition()
    }
    lastIMEIKeyRef.current = ''
  }

  const handleKeyDown = (event) => {
    lastIMEIKeyRef.current = event.key
    if (IMEI_DELETE_KEYS.includes(event.key)) {
      captureIMEIDeleteScrollPosition()
    }

    if (event.ctrlKey || event.metaKey || event.altKey) return

    if (event.key.length === 1 && !/[0-9]/.test(event.key)) {
      event.preventDefault()
    }
  }

  const lookupIMEI = async (imeiToLookup = customerIMEI, continueOnCompatible = true) => {
    const parsedIMEI = imeiToLookup.trim()
    if (!isIMEIComplete(parsedIMEI)) {
      setHasImeiFormatError(true)
      return {
        imeiFound: false,
        imeiCompatible: false
      }
    }

    setLoading(true)
    setHasImeiFormatError(false)
    try {
      const deviceInfoResponse = await getDeviceInfo(BrandName, parsedIMEI)
      const { data = {} } = deviceInfoResponse || {}

      const {
   imageURL, enabledESIM, voLteSupportStatusCode, manufacturerName, modelName
  } = data
      const isIMEICompatible = isApiFlagTrue(enabledESIM)
      const isVoLteCompatible = isApiFlagTrue(voLteSupportStatusCode)
      let isIMEIFound = false

      if (manufacturerName && modelName) {
        isIMEIFound = true
        pushClickAnalytics({ click_text: pageTextContent?.checkIMEI, journey_type: simType ?? 'eSIM',event_type: 'Check IMEI is successfull' })
      } else {
        pushClickAnalytics({ click_text: pageTextContent?.checkIMEI, journey_type: simType ?? 'eSIM', field_warning: `${deviceInfoResponse?.error?.message} IMEI not found`, error_response_code: deviceInfoResponse?.error?.code ?? '401', event_type: 'IMEI validation failed' })
        isIMEIFound = false
      }
    
      if (latestIMEIRef.current && latestIMEIRef.current !== parsedIMEI) {
        return {
          imeiFound: isIMEIFound,
          imeiCompatible: isIMEICompatible
        }
      }

      setIMEIFound(isIMEIFound)
      hasClearedCurrentIMEIResultRef.current = false

      updateIMEICompatibilityCheck({
        imei: parsedIMEI,
        imeiChecked: isIMEIFound,
        imeiCompatible: isIMEICompatible
      })

      const deviceInfoData = {
        imageURL,
        eSimCompatible: isIMEICompatible,
        lteEnabled: isVoLteCompatible,
        manufacturer: manufacturerName,
        model: modelName
      }
      setDeviceInfo(deviceInfoData)

      const canContinueAfterLookup = isIMEICompatible || autoLookup
      if (continueOnCompatible && isIMEIFound && canContinueAfterLookup && onCompatibleContinue) {
        onCompatibleContinue()
      }

      return {
        imeiFound: isIMEIFound,
        imeiCompatible: isIMEICompatible
      }
    } catch (error) {
      if (latestIMEIRef.current && latestIMEIRef.current !== parsedIMEI) {
        return {
          imeiFound: false,
          imeiCompatible: false
        }
      }

      setIMEIFound(false)
      pushClickAnalytics({
        click_text: pageTextContent?.checkIMEI,
        journey_type: simType ?? 'eSIM',
        field_warning: 'IMEI lookup failed',
        error_response_code: '500',
        event_type: 'IMEI validation failed'
      })
      return {
        imeiFound: false,
        imeiCompatible: false
      }
    } finally {
      if (!latestIMEIRef.current || latestIMEIRef.current === parsedIMEI) {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    if (!autoLookup || !isAutoLookupReady(customerIMEI)) return undefined
    if (lastAutoLookupIMEIRef.current === customerIMEI) return undefined

    const timer = setTimeout(() => {
      lastAutoLookupIMEIRef.current = customerIMEI
      lookupIMEI(customerIMEI, false)
    }, 400)

    return () => clearTimeout(timer)
  }, [autoLookup, customerIMEI])

  useEffect(() => () => {
    if (imeiScrollRestoreFrameRef.current !== null) {
      if (typeof window !== 'undefined' && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(imeiScrollRestoreFrameRef.current)
      } else {
        clearTimeout(imeiScrollRestoreFrameRef.current)
      }
    }
    clearTimeout(imeiScrollRestoreTimerRef.current)
    clearTimeout(imeiHeightReleaseTimerRef.current)
  }, [])

  useEffect(() => {
    if (preservedIMEISectionHeight === 0 || typeof document === 'undefined') {
      return undefined
    }

    const handlePointerDown = () => {
      imeiPointerActiveRef.current = true
      clearTimeout(imeiHeightReleaseTimerRef.current)
    }
    const handlePointerUp = () => {
      // Keep the interaction active through a possible compatibility click.
      // Mobile browsers may blur the input after pointerup but before click.
      clearTimeout(imeiHeightReleaseTimerRef.current)
      imeiHeightReleaseTimerRef.current = setTimeout(() => {
        imeiPointerActiveRef.current = false
        if (imeiHeightReleasePendingRef.current) {
          releaseIMEIAutoLookupSectionHeight()
        }
      }, IMEI_POINTER_RELEASE_FALLBACK_MS)
    }
    const handleCompletedPointerInteraction = () => {
      clearTimeout(imeiHeightReleaseTimerRef.current)
      imeiPointerActiveRef.current = false
      if (imeiHeightReleasePendingRef.current) {
        scheduleIMEIAutoLookupSectionHeightRelease()
      }
    }

    document.addEventListener('pointerdown', handlePointerDown, true)
    document.addEventListener('pointerup', handlePointerUp, true)
    document.addEventListener('pointercancel', handleCompletedPointerInteraction, true)
    document.addEventListener('click', handleCompletedPointerInteraction, true)
    document.addEventListener('contextmenu', handleCompletedPointerInteraction, true)

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown, true)
      document.removeEventListener('pointerup', handlePointerUp, true)
      document.removeEventListener('pointercancel', handleCompletedPointerInteraction, true)
      document.removeEventListener('click', handleCompletedPointerInteraction, true)
      document.removeEventListener('contextmenu', handleCompletedPointerInteraction, true)
      clearTimeout(imeiHeightReleaseTimerRef.current)
    }
  }, [
    preservedIMEISectionHeight,
    releaseIMEIAutoLookupSectionHeight,
    scheduleIMEIAutoLookupSectionHeightRelease
  ])

  const imeiLookupFailed = () => {
    return foundIMEI === false
  }

  const imeiLookupSucceeded = () => {
    return foundIMEI === true
  }

  const imeiIsCompatible = imeiLookupSucceeded() && deviceInfo?.eSimCompatible
  const imeiIsIncompatible = imeiLookupSucceeded() && deviceInfo && !deviceInfo.eSimCompatible
  const imeiNotFound = imeiLookupFailed()
  // Derive the message at render time so it always reflects the current
  // language; storing the resolved string in state would freeze it on the
  // language active when the error was first triggered.
  const imeiError = hasImeiFormatError ? (pageTextContent?.imeiInvalid || '') : ''
  const imeiHasError = hasImeiFormatError || imeiIsIncompatible || imeiNotFound

  const choosePSim = () => {
    pushClickAnalytics({ click_text: pageTextContent?.getNewPhysicalSIM, journey_type: 'pSIM', event_type: 'pSIM is choosen'}) 
    if (onChoosePSim) {
      onChoosePSim()
      return
    }
    dispatch(setSimType({
      simType: SIM_OPTIONS.P_SIM,
      cost: pSimPrice
    }))
  }

  const handleContinueClick = () => {
    if (autoLookup && (imeiLookupSucceeded() || imeiNotFound) && onCompatibleContinue) {
      onCompatibleContinue()
      return
    }

    lookupIMEI()
  }

  const imeiLookUpFeedback = () => {
    return (
      <>
        {imeiLookupSucceeded() && deviceInfo && (
          <PhoneDetails
            phoneImage={deviceInfo?.imageURL}
            eSimCompatible={deviceInfo?.eSimCompatible}
            lteCompatible={deviceInfo?.lteEnabled}
            imei={imei}
            manufacturer={deviceInfo?.manufacturer}
            model={deviceInfo?.model}
            onChoosePSimClick={choosePSim}
            layout={autoLookup ? 'panel' : 'default'}
            showIncompatibleMessage={!autoLookup}
            userType={Sites.consumer}
          />
        )}
      </>
    )
  }

  const getInputValidation = () => {
    if (imeiHasError) return 'error'
    if (imeiIsCompatible) return 'success'
    return undefined
  }

  const getIMEIInputClassName = () => {
    if (imeiHasError) return 'relative w-full kpre-imei-error-input'
    if (imeiIsCompatible) return 'relative w-full kpre-imei-success-input'
    return 'relative w-full'
  }

  const getIMEIInputTokens = () => {
    const defaultTokens = {
      borderRadius: 4
    }

    if (imeiHasError) {
      return {
        ...defaultTokens,
        backgroundColor: '#ffffff',
        borderColor: '#c9370b',
        borderWidth: 1,
        outerBorderColor: 'transparent',
        outerBorderWidth: 0,
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        validationIcon: null,
        validationIconColor: 'rgba(0, 0, 0, 0)',
        paddingRight: 56
      }
    }

    if (imeiIsCompatible) {
      return {
        ...defaultTokens,
        backgroundColor: '#ffffff',
        borderColor: '#1c7b2b',
        borderWidth: 1,
        outerBorderColor: 'transparent',
        outerBorderWidth: 0,
        icon: null,
        iconColor: 'rgba(0, 0, 0, 0)',
        validationIcon: null,
        validationIconColor: 'rgba(0, 0, 0, 0)',
        paddingRight: 56
      }
    }

    return defaultTokens
  }

  const getSentenceWithPeriod = (value) => {
    const text = `${value || ''}`.trim()
    if (!text) return ''
    return /[.!?]$/.test(text) ? text : `${text}.`
  }

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  const getIMEINotFoundMessage = () => {
    const message = `${pageTextContent?.imeiNotFoundMessage || ''}`.trim()
    const heading = `${pageTextContent?.imeiNotFound || ''}`.trim().replace(/[.!?]$/, '')
    if (!message) return ''
    return message.replace(new RegExp(`^${escapeRegExp(heading)}[.!?]?\\s*`, 'i'), '')
  }

  const getIncompatibleBodyMessage = () => {
    const message = `${pageTextContent?.eSimNotCompatibleMessage || ''}`.trim()
    const heading = `${pageTextContent?.eSimIncompatible || ''}`.trim().replace(/[.!?]$/, '')
    if (!message || !heading) return message
    return message.replace(new RegExp(`^${escapeRegExp(heading)}[.!?]?\\s*`, 'i'), '').trim()
  }

  const renderIMEINotFoundFeedback = () => {
    if (!imeiNotFound) return null

    return (
      <div
        className="mt-1 w-full bg-[#fbd1c5] px-4 py-3 text-black"
        data-testid="sim-selection-imei-not-found-feedback"
        role="alert"
      >
        <Typography
          variant={{ size: 14, bold: true, color: '#000000' }}
          tokens={BODY_BOLD_TOKENS}
        >
          {getSentenceWithPeriod(pageTextContent?.imeiNotFound)}
        </Typography>
        {' '}
        <Typography
          variant={{ size: 14, color: '#000000' }}
          tokens={BODY_COPY_TOKENS}
        >
          {getIMEINotFoundMessage()}
        </Typography>
      </div>
    )
  }

  const renderIncompatibleWarning = () => {
    if (!autoLookup || !imeiIsIncompatible) return null

    const headline = getSentenceWithPeriod(pageTextContent?.eSimIncompatible)
    const bodyMessage = getIncompatibleBodyMessage()

    return (
      <div className="mb-6 mr-1 bg-[#fbd1c5] px-4 py-3 text-black" role="alert">
        <div>
          <Typography
            variant={{ size: 14, bold: true, color: '#000000' }}
            tokens={BODY_BOLD_TOKENS}
          >
            {headline}
          </Typography>
          {' '}
          {bodyMessage && (
            <>
              <Typography
                variant={{ size: 14, color: '#000000' }}
                tokens={BODY_COPY_TOKENS}
              >
                <InlineInstructionMarkdown>
                  {bodyMessage}
                </InlineInstructionMarkdown>
              </Typography>
              {' '}
            </>
          )}
        </div>
      </div>
    )
  }

  const renderIMEIInput = () => (
    <div ref={imeiInputContainerRef} className="w-full">
      <div className={getIMEIInputClassName()}>
        <KoodoInput
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          id={IMEI_INPUT_ID}
          label={pageTextContent?.enterYourIMEI}
          maxLength={15}
          value={customerIMEI}
          onChange={onIMEIChange}
          onKeyDown={handleKeyDown}
          feedback={imeiError || undefined}
          validation={getInputValidation()}
          tokens={getIMEIInputTokens()}
          height={44}
          testId="sim-selection-enter-your-imei-input"
        />
        {imeiIsCompatible && (
          <span
            className="pointer-events-none absolute bottom-[10px] right-4 flex h-6 w-6 items-center justify-center"
            data-testid="sim-selection-imei-success-icon"
            aria-hidden="true"
          >
            <Icon icon="CheckCircleFilled" variant={{ color: 'success', size: 'small' }} />
          </span>
        )}
        {imeiHasError && (
          <span
            className="pointer-events-none absolute bottom-[10px] right-4 flex h-6 w-6 items-center justify-center"
            data-testid="sim-selection-imei-error-icon"
            aria-hidden="true"
          >
            <Icon icon="ExclamationOctagon" variant={{ color: 'danger', size: 'small' }} />
          </span>
        )}
      </div>
      {renderIMEINotFoundFeedback()}
    </div>
  )

  const renderContinueButton = () => (
    <div className="w-full sm:w-[135px]">
      {continueLabel ? (
        <KoodoButton
          variant={{ priority: 'high', width: isMobileScreen ? 'full' : 'responsive' }}
          tokens={{
            borderRadius: 4,
            ...(!isMobileScreen ? { height: 44 } : {}),
            minWidth: 120,
            paddingLeft: 18,
            paddingRight: 18
          }}
          onPress={handleContinueClick}
          loading={loading}
          loadingLabel={continueLabel}
          testId={continueTestId}
        >
          {continueLabel}
        </KoodoButton>
      ) : (
        <RoundedButton
          onClick={handleContinueClick}
          label={pageTextContent?.checkIMEI}
          disabled={disableIMEI}
          isLoading={loading}
          internalLoader
          testId={continueTestId}
        />
      )}
    </div>
  )

  return (
    <div
      ref={imeiCompatibilityRef}
      className={`${showTopBorder ? 'mt-4 pt-6 border-t' : ''} text-black`}
      data-testid="sim-selection-imei-section"
      onFocusCapture={handleIMEISectionFocus}
      onBlurCapture={handleIMEISectionBlur}
      style={{
        color: '#000000',
        ...(preservedIMEISectionHeight > 0
          ? { minHeight: `${preservedIMEISectionHeight}px` }
          : {})
      }}
    >
      <div
        className="mb-4"
        data-contentful-slug="beforeYouProceedHeading"
      >
        <Typography
          variant={{ size: 20, bold: true, color: '#000000' }}
          tokens={SECTION_HEADING_TOKENS}
        >
          {pageTextContent?.beforeYouProceedHeading}
        </Typography>
      </div>
      <div className="kpre-esim-instruction-panel mb-6 p-6 bg-[#f2f2f2] rounded-sm text-black">
        {pageTextContent?.eSimBenefitsMessage && (
          <div
            className="kpre-esim-benefits-message mb-3"
            data-contentful-slug="eSimBenefitsMessage"
          >
            <Typography
              variant={{ size: 14, color: '#000000' }}
              tokens={BODY_COPY_TOKENS}
            >
              {pageTextContent.eSimBenefitsMessage}
            </Typography>
          </div>
        )}
        <div
          className="kpre-esim-instruction-heading mb-3"
          data-contentful-slug="eSimImeiInstructions"
        >
          <Typography
            variant={{ size: 14, color: '#000000' }}
            tokens={INSTRUCTION_HEADING_TOKENS}
          >
            {pageTextContent?.eSimImeiInstructions}
          </Typography>
        </div>
        <ul
          className="kpre-esim-instruction-list list-disc list-outside pl-5 space-y-1 text-black"
          style={{ color: '#000000' }}
        >
          <li data-contentful-slug="checkPhoneSettings">
            <Typography
              variant={{ size: 14, color: '#000000' }}
              tokens={BODY_COPY_TOKENS}
            >
              <InlineInstructionMarkdown>
                {pageTextContent?.checkPhoneSettings}
              </InlineInstructionMarkdown>
            </Typography>
          </li>
          <li data-contentful-slug="dialPhoneCode">
            <Typography
              variant={{ size: 14, color: '#000000' }}
              tokens={BODY_COPY_TOKENS}
            >
              <InlineInstructionMarkdown>
                {pageTextContent?.dialPhoneCode}
              </InlineInstructionMarkdown>
            </Typography>
          </li>
        </ul>
      </div>
      {autoLookup ? (
        <>
          <div className={`${imeiIsIncompatible ? 'mb-1' : 'mb-6'} pr-1`}>
            {renderIMEIInput()}
          </div>
          {renderIncompatibleWarning()}
          {imeiLookUpFeedback()}
          <div className="mt-6">
            {renderContinueButton()}
          </div>
        </>
      ) : (
        <>
          {isMobile && imeiLookUpFeedback()}
          <div className="mb-0 sm:mb-6 pr-1">
            {renderIMEIInput()}
            <div className="mt-6">
              {renderContinueButton()}
            </div>
          </div>
          {!isMobile && imeiLookUpFeedback()}
        </>
      )}
    </div>
  )
}

ConsumerESIMCompatibility.propTypes = {
  autoLookup: PropTypes.bool,
  continueLabel: PropTypes.string,
  continueTestId: PropTypes.string,
  onCompatibleContinue: PropTypes.func,
  onChoosePSim: PropTypes.func,
  showTopBorder: PropTypes.bool
}

export default ConsumerESIMCompatibility
